import { OrderDetail } from "@omni/types/api/cart/bff/orderDetail.model";
import { OrderCustomer } from "@omni/types/api/cart/bff/shared/orderCustomer.model";
import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { ProductConfiguration } from "@omni/types/utils/productConfiguration";
import { Translate } from "@omni/types/utils/translate";
import { pick } from "lodash-es";

export const productIsAdditionalService = (
    items: Array<OrderItem>,
    id?: string
) => {
    return (
        !!id &&
        items.some((i) => i.additionalServices?.map((as) => as.id).includes(id))
    );
};

export const showDeliveryCost = (orderDetails: OrderDetail) => {
    return orderDetails.items.some(
        (i) => i.deliveryType === DeliveryType.HomeDelivery
    );
};

export const hasGiftCardPayments = (orderDetails: OrderDetail) => {
    return (orderDetails.giftCardPayments || []).length > 0;
};

export const showStrippedPrice = (orderItem: OrderItem) => {
    return !!orderItem.strikethroughPrice;
};

export const getTitle = (orderItem: OrderItem, t: Translate) => {
    if (orderItem.articleConfiguration) {
        return orderItem.articleConfiguration.title || "";
    }

    const name = orderItem.product?.productTitle;
    if (name === null || orderItem.warrantyDeposit) {
        return t("general.product.pallet.title");
    }

    return name;
};

export const getUrl = (orderItem: OrderItem, giftcardPage: string) => {
    if (orderItem.product?.giftCardArticle) {
        return giftcardPage;
    } else if (orderItem.articleConfiguration) {
        return undefined;
    }

    return orderItem.product?.url;
};

export const getConfiguration = (
    orderItem: OrderItem,
    productConfigurations: Array<ProductConfiguration>
) => {
    return pick(
        orderItem,
        productConfigurations.reduce(
            (acc, pc) => [...acc, ...pc.configPaths],
            [] as string[]
        )
    );
};

export const isCustomerB2B = (orderCustomer: OrderCustomer) => {
    return !!orderCustomer.btwNumber && !!orderCustomer.companyName;
};

export const isBoxEntry = (orderItem: OrderItem) => {
    return orderItem.boxEntry || orderItem.tellerEntry;
};
